import { Environment } from '@campaign-portal/components-library';

export const environment: Environment = {
	production: true,
	version: '1.7.1-0.sha.b3ae18b',
	releaseDate: '09 December 2025',

	protocol: '',
	host: '',
	port: '',
	api: 'api',
	localStorageKey: 'ap',
	configURL: `./assets/config.json?v=${new Date().getTime()}`,

	title: 'Alaris Labs',
	subTitle: 'Admin Panel',

	theme: 'default',
	themeType: window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light',

	termsUrl: '',
	privacyUrl: '',
	supportEmail: '',

	showLink: true,
	allowRegistration: false,
	supportLetsEncrypt: true,

	systemTZOffset: 0,
	localTime: false,

	languagesID: ['en', 'es', 'tr'],

	is2FA: false,
	sessionTimeout: 60,
};
